export default {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'var(--color-bg-paper)',
        borderRadius: '8px',

        '& fieldset': {
          borderColor: 'var(--color-border)',
        },

        '&:hover fieldset': {
          borderColor: 'var(--color-primary)',
        },

        '&.Mui-focused fieldset': {
          borderColor: 'var(--color-primary)',
          borderWidth: 2,
        },

        '&.Mui-error fieldset': {
          borderColor: 'var(--color-error)',
        },

        '&.Mui-disabled': {
          backgroundColor: 'var(--color-action-disabled-bg)',

          '& fieldset': {
            borderColor: 'var(--color-border)',
          },
        },
      },

      '& .MuiOutlinedInput-input': {
        color: 'var(--color-text-primary)',
        padding: '12px 14px',

        '&::placeholder': {
          color: 'var(--color-text-muted)',
          opacity: 1,
        },

        '&.Mui-disabled': {
          color: 'var(--color-text-disabled)',
        },
      },

      '& .MuiInputLabel-root': {
        color: 'var(--color-text-secondary)',

        '&.Mui-focused': {
          color: 'var(--color-primary)',
        },

        '&.Mui-error': {
          color: 'var(--color-error)',
        },

        '&.Mui-disabled': {
          color: 'var(--color-text-disabled)',
        },
      },

      '& .MuiFormHelperText-root': {
        marginLeft: 4,
        color: 'var(--color-text-muted)',

        '&.Mui-error': {
          color: 'var(--color-error)',
        },
      },
    },
  },
};
